"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const gear = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-gear` : '') + (description ? ` desc-gear` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-gear"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-gear"
  }, description), /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#clip0_24792_8480)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M20.16 12a2.71 2.71 0 0 1 .9-2.01l1.04-.94a1.2 1.2 0 0 0-.87-2.1l-1.4.07a2.7 2.7 0 0 1-2.84-2.84l.07-1.4v-.2a1.2 1.2 0 0 0-2.1-.68L14 2.94a2.7 2.7 0 0 1-4.02 0L9.05 1.9l-.13-.12a1.2 1.2 0 0 0-1.97 1l.07 1.4v.27a2.7 2.7 0 0 1-2.85 2.57l-1.4-.07a1.2 1.2 0 0 0-1 1.97l.13.13 1.05.95a2.7 2.7 0 0 1 0 4.02l-1.05.94a1.2 1.2 0 0 0 .88 2.1l1.4-.07h.28a2.7 2.7 0 0 1 2.56 2.84l-.07 1.4a1.2 1.2 0 0 0 2.1.87l.95-1.04a2.71 2.71 0 0 1 4.02 0l.93 1.03a1.21 1.21 0 0 0 2.1-.86l-.07-1.4a2.71 2.71 0 0 1 2.85-2.85l1.4.08a1.21 1.21 0 0 0 .87-2.1L21.06 14a2.71 2.71 0 0 1-.9-2.01Zm1.5 0a1.2 1.2 0 0 0 .4.9l1.04.94a2.71 2.71 0 0 1-1.95 4.71l-1.4-.07a1.21 1.21 0 0 0-1.27 1.27l.07 1.4a2.7 2.7 0 0 1-4.7 1.96l-.95-1.05a1.21 1.21 0 0 0-1.7-.09l-.1.1-.94 1.03a2.71 2.71 0 0 1-4.7-1.94l.06-1.4a1.2 1.2 0 0 0-1.14-1.28h-.13l-1.4.08A2.7 2.7 0 0 1 .9 13.84l1.04-.94a1.21 1.21 0 0 0 .09-1.7l-.1-.1-1.03-.94a2.71 2.71 0 0 1 1.94-4.7l1.4.06h.13a1.2 1.2 0 0 0 1.15-1.27l-.07-1.4a2.71 2.71 0 0 1 4.56-2.1l.15.14.94 1.05a1.2 1.2 0 0 0 1.8 0l.95-1.05a2.7 2.7 0 0 1 4.71 1.75v.21l-.07 1.4a1.2 1.2 0 0 0 1.26 1.27l1.4-.07a2.71 2.71 0 0 1 2.1 4.57l-.15.14-1.04.94a1.21 1.21 0 0 0-.4.9Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M15.75 12a3.75 3.75 0 1 0-7.5 0 3.75 3.75 0 0 0 7.5 0Zm1.5 0a5.25 5.25 0 1 1-10.5 0 5.25 5.25 0 0 1 10.5 0Z",
    fill: "#232323"
  })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "clip0_24792_8480"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    width: "24",
    height: "24",
    fill: "white"
  }))));
};
var _default = exports.default = gear;